import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import FeedbackForm from './FeedbackForm';
import styles from './FeedbackButton.module.css';

const FeedbackButton: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <>
      <button
        className={styles.feedbackBtn}
        onClick={() => setShowForm(true)}
        aria-label="Give Feedback"
        title="Give Feedback"
        data-feedback-button
      >
        <MessageSquare size={24} />
      </button>

      {showForm && (
        <FeedbackForm
          onClose={() => setShowForm(false)}
          onSuccess={handleSuccess}
        />
      )}

      {showSuccess && (
        <div className={styles.successToast}>
          <MessageSquare size={20} />
          <span>Thank you for your feedback!</span>
        </div>
      )}
    </>
  );
};

export default FeedbackButton;
